import { render } from "./Greeting.vue?vue&type=template&id=3cb68745&scoped=true"
import script from "./Greeting.vue?vue&type=script&lang=js"
export * from "./Greeting.vue?vue&type=script&lang=js"

import "./Greeting.vue?vue&type=style&index=0&id=3cb68745&scoped=true&lang=css"

import exportComponent from "/Users/admin/Downloads/project_output 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb68745"]])

export default __exports__